// https://github.com/alphagov/govuk-frontend/blob/master/src/components/table/_table.scss

import styled from 'styled-components';

const Row = styled('tr')({});

export default Row;
